import { generate } from "../../helpers/element/generate-element";
import { slideDown } from "../../helpers/utils/slide";

class CalculatorPlanter {
    constructor() {
        // Discount configuration
        this.discount = {
            percentage: 20, // Discount percentage (e.g., 20 for 20% off)
            startDate: '2026-05-28 00:00:00', // Start date with time
            endDate: '2026-06-07 23:59:59' // End date with time
        };

        this.requiredInputs = [
            'length',
            'width',
            'height',
            'thickness',
            'finish',
            'base_feet',
            'quantity'
        ];

        this.inputGroups = [];
        this.values = [];
        this.costValue;
        this.hasDisplayed = false;

        this.defaultVariables = {
            ppmm_value: 0.006,
            thickness: 37,
        };

        if (this.canInit()) {
            this.getInputs();
            this.addEvents();
        }
    }

    canInit() {
        return document.querySelector('.js-calc-form[data-form=planter]') !== null;
    }

    getInputs() {
        const inputGroups = document.querySelectorAll('.js-calc-form .af-field');

        this.inputGroups = [...inputGroups].filter((group) => {
            return this.requiredInputs.includes(group.dataset.name);
        });
    }

    addEvents() {
        const trigger = document.querySelector('.js-calculate.button');

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.handleClick();
        })
    }

    handleClick() {
        this.getVariableValues();
        if (this.getInputValues()) {
            this.doCalculation();
            this.displayValues();
        }
    }

    getVariableValues() {
        let definedVariables = {};

        if (typeof values_data !== 'undefined' && values_data !== null) {
            definedVariables = values_data;
        }

        this.variables = { ...this.defaultVariables, ...definedVariables };
    }

    getInputValues() {
        let out = true;
        this.inputGroups.forEach((inputGroup) => {
            const name = inputGroup.dataset.name;
            const input = inputGroup.querySelector('input');
            const select = inputGroup.querySelector('select');
            let value;

            let errors = inputGroup.querySelectorAll('.error');
            for (var i = 0; i < errors.length; i++) {
                errors[i].remove();
            }

            if (input !== null) {
                value = input.value;
            }

            if (select !== null) {
                value = select.options[select.selectedIndex].value;;
            }

            if (name == 'length' || name == 'width' || name == 'height') {
                if (value > 3900) {
                    out = false;
                    let error = generate('div', name + ' cannot be longer than 3900mm', []);
                    error.classList.add('error');
                    inputGroup.append(error);
                }
                if (value < 300) {
                    out = false;
                    let error = generate('div', name + ' must be longer than 300mm', []);
                    error.classList.add('error');
                    inputGroup.append(error);
                }
            }

            this.values['_' + name] = value;
        });
        return out;
    }

    doCalculation() {
        // Input Values
        const hasFeet = this.values._base_feet === "yes";
        const finishType = this.values._finish;
        const quantity = parseInt(this.values._quantity, 10);
        const length = parseInt(this.values._length, 10);
        const height = parseInt(this.values._height, 10);
        const width = parseInt(this.values._width, 10);

        const ppmm = this.variables.ppmm_value;
        const thickness = this.variables.thickness;

        const boards = Math.ceil(height / 200);
        const sides = (2 * boards) * quantity;
        const ends = (2 * boards) * quantity;
        const posts = quantity * 5;
        const frontAndBack = thickness * 2;
        const endsLength = width - frontAndBack;
        const linear = ((sides * length) + (ends * endsLength)) / quantity;
        const layer = (length + width) * 2;
        const squareM = (layer * height) / 1000000;
        const sideEndCost = (linear * ppmm);
        const breakout = (linear / 1000) + 10;
        const rout = ((layer / 1000) + 10);
        const sand = (squareM * 5) + 7;
        const ass = ((boards * (layer * 1.5)) / 1000);
        const uvp = 25 + (squareM * 15);
        const stain = squareM + 6;
        const sandedPrice = sideEndCost + breakout + rout + sand + ass;
        let finishCost = uvp + stain;
        if (finishType == 'smooth') {
            finishCost = sand;
        } else if (finishType == 'clear') {
            finishCost = uvp;
        }

        const baseBoards = Math.ceil(width / 225);
        const baseBoardsTotal = baseBoards * quantity;
        const baseBoardsWidth = Math.ceil(width/baseBoards);
        const feet = Math.floor(2 + (length / 2200));
        const feetTotal = (Math.floor(2 + (length / 2200))) * quantity;

        const f1 = hasFeet ? baseBoardsTotal : 0;
        const f2 = hasFeet ? length : 0;
        const baseCost = ((f1*f2)*ppmm) + (feet*3);
        const baseCostEach = this.round((baseCost / quantity), 2);

        const baseAss = 3 * baseBoards;
        const totalBaseCost = hasFeet ? (baseAss + baseCostEach) : 0;
        const price = totalBaseCost + finishCost + sandedPrice;
        const priceEach = Math.ceil(price) * 1.1;
        const totalPrice = priceEach * quantity;

        this.costValue = totalPrice.toFixed(2);
    }

    displayValues() {
        const container = document.querySelector('.calc-form-sum__calculated');

        const submitButtons = document.querySelector('.af-submit');
        const costArea = document.querySelector('.calc-form-sum__cost');

        if (this.costValue === "NaN") {
            container.classList.add('has-error');
            const costElem = generate('span', `Please enter all values`, []);
            costArea.classList.add('is-hidden');

            setTimeout(() => {
                costArea.innerHTML = '';
                costArea.appendChild(costElem);
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                }, 300);
            }

            if (this.hasDisplayed) {
                slideUp(submitButtons, 300);
                this.hasDisplayed = false;
            }
        } else {
            container.classList.remove('has-error');
            costArea.classList.add('is-hidden');

            let priceHtml;
            if (this.isDiscountActive()) {
                const originalPrice = parseFloat(this.costValue);
                const discountedPrice = this.round(originalPrice * (1 - this.discount.percentage / 100), 2);
                priceHtml = `
                    <div class="price-display">
                        <span class="original-price">£${this.costValue}</span>
                        <span class="discounted-price">£${discountedPrice.toFixed(2)}</span>
                    </div>
                `;
            } else {
                priceHtml = `£${this.costValue}`;
            }

            setTimeout(() => {
                costArea.innerHTML = priceHtml;
                costArea.classList.remove('is-hidden');
            }, 300);

            if (!this.hasDisplayed) {
                setTimeout(() => {
                    slideDown(submitButtons, 300, 'flex');
                    slideDown(container, 300, 'flex');
                    container.classList.add('is-active');
                    this.hasDisplayed = true;
                }, 300);
            }

        }
    }

    round(num, decimals) {
        return Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals);
    }

    isDiscountActive() {
        const currentDate = new Date();
        const startDate = new Date(this.discount.startDate.replace(' ', 'T'));
        const endDate = new Date(this.discount.endDate.replace(' ', 'T'));
        
        return currentDate >= startDate && currentDate <= endDate;
    }
}

export const calculatorPlanter = () => {
    new CalculatorPlanter(); // eslint-disable-line no-new
};
